import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { wbp, reduceResolution } from 'Theme';
import Carousel from 'components/UI/V2/Carousel/Carousel';
import { getAddonSlides } from './Slides';
import AddonDescription from './AddonDescription';
import ReactDOMServer from 'react-dom/server';

interface EmptyProps {
    onAdd?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            'flex': 1,

            'fontSize': 15,

            'display': 'flex',
            'flexDirection': 'column',
            'justifyContent': 'center',
            'alignItems': 'center',

            '& .MuiTypography-root': {
                maxWidth: 370,
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        },
        icon: {
            'margin': '0px auto 15px',
            '& svg': {
                marginRight: -10
            }
        },
        paragraph: {
            fontSize: 15,
            lineHeight: 1.4,
            marginBottom: 20
        },
        button: {
            [theme.breakpoints.down(wbp)]: {
                width: `${reduceResolution(280)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                width: '280px'
            }
        }
    })
);

export const Empty: FunctionComponent<EmptyProps> = props => {
    const classes = useStyles();

    const addonDescriptionHTML = ReactDOMServer.renderToString(<AddonDescription />);
    const addonSlides = getAddonSlides(addonDescriptionHTML, props.onAdd);

    return (
        <Box className={classes.root}>
            <Carousel slides={addonSlides} />
        </Box>
    );
};

export default Empty;
